import { StoreData } from "../../types";
import { getRequestWrapper } from "../../utilities";

// Response ----------

export type getAssociatedStoresByAppIdResponse = { body: StoreData[] };

// Request ----------

// TODO - Rethink name.
export function getAssociatedStoresByAppId(
  id: string
): Promise<getAssociatedStoresByAppIdResponse> {
  return getRequestWrapper<never, getAssociatedStoresByAppIdResponse>({
    url: `${ENV_SETTINGS.API_URL}/apps/${id}/stores`,
  });
}
